import { ReactElement, useContext } from 'react';
import { CategoriesContext } from '../App';

interface Breadcrumb {
    name: string;
    url: string;
}

export interface HeaderRenderProps {
    breadcrumbs: Breadcrumb[];
    lastIdx: number;
}

interface HeaderProps {
    render: (props: HeaderRenderProps) => ReactElement | null;
}

function Header({ render }: HeaderProps) {
    const { pathname, categorySlugs, isProduct, productSlug, categories, product } = useContext(CategoriesContext);

    const breadcrumbs: Breadcrumb[] = [{ name: 'Каталог продукции', url: '/' }];

    if (pathname === '/search/') {
        breadcrumbs.push({ name: 'Поиск', url: '/search/' });
    } else {
        let currentCategories = categories;
        const path = [];
        for (const part of categorySlugs) {
            path.push(part);
            const category = currentCategories.find(({ slug }) => slug === part);
            if (category) {
                if (category.children) {
                    currentCategories = category.children;
                } else {
                    currentCategories = [];
                }
                breadcrumbs.push({
                    name: category.name,
                    url: category.url,
                });
            } else {
                breadcrumbs.push({
                    name: 'Неизвестная категория',
                    url: '/' + path.join('/') + '/',
                });
            }
        }
        if (isProduct) {
            path.push(productSlug);
            if (product) {
                breadcrumbs.push({
                    name: product.name,
                    url: product.url,
                });
            } else {
                breadcrumbs.push({
                    name: 'Неизвестный продукт',
                    url: '/' + path.join('/'),
                });
            }
        }
    }
    const lastIdx = breadcrumbs.length - 1;
    const Render = render;
    return <Render breadcrumbs={breadcrumbs} lastIdx={lastIdx} />;
}

export default Header;
